import { useEffect } from "react";
import { Loader2 } from "lucide-react";
import { AreaShell } from "@/components/area/AreaShell";

// /area-riservata moved to the full ZERAMI web app: send old links there.
export default function RedirectRiservata() {
  const target = process.env.REACT_APP_RESERVED_AREA_URL;
  useEffect(() => {
    if (target) window.location.replace(target);
  }, [target]);
  return (
    <AreaShell testId="area-riservata-redirect" title="Area Riservata" subtitle="Ti stiamo portando all'app ZERAMI…">
      <Loader2 className="mx-auto h-8 w-8 animate-spin text-zr-green" />
      <p className="mt-4 text-sm text-zr-grey">
        Se non vieni reindirizzato,{" "}
        <a href={target} data-testid="riservata-redirect-link" className="font-semibold text-zr-blue underline">clicca qui</a>.
      </p>
    </AreaShell>
  );
}
